import { useMutation } from 'react-query';
import { writeStorage } from '@rehooks/local-storage';
import { api } from '../../api';
import { LOCALSTORAGE_USER_ID } from '../../constants';

export const useCreateUserMutation = () =>
  useMutation(api.users.create, {
    onSuccess: ({ userId }) => {
      writeStorage(LOCALSTORAGE_USER_ID, userId.toString());
    },
  });
